import { get, post } from "services/services.methods";
import { PurchaseOrdersPaths, PurchaseOrdersReportsPaths } from 'services/services.paths';
import { GenericApiResponse, PurchaseOrdersR, PurchaseOrdersReport } from "interfaces";

export const createPurchaseOrdersRegistration = async (PurchaseOrder: PurchaseOrdersR) => {
  const response = await post<any>(PurchaseOrdersPaths.post, PurchaseOrder);

  return response;
};



export const getlistPurchase = async (
  purchaseParams: { providerId: number; dateFrom: string; dateTo: string; purchaseId: number }
): Promise<GenericApiResponse<PurchaseOrdersReport[]>> => {
  
  const url = `${PurchaseOrdersReportsPaths.post}?providerId=${purchaseParams.providerId}&dateFrom=${purchaseParams.dateFrom}&dateTo=${purchaseParams.dateTo}&purchaseId=${purchaseParams.purchaseId}`;
  const response = await post<PurchaseOrdersReport[]>(PurchaseOrdersReportsPaths.post, purchaseParams);


  return response;
};


